/** Optional birthday confirmation must not send an empty Magento customer input. */
export const saveOptionalBirthday = async _ref => {
  let {
    dob,
    updateCustomer
  } = _ref;
  if (typeof dob !== "string" || !dob.trim()) return;
  return updateCustomer({
    variables: {
      dob: dob.trim()
    }
  });
};